export default {
  shape:
    '<path fill="#22CCD8" d="m9.55 17.3-4.975-4.95.725-.725 4.25 4.25 9.15-9.15.725.725L9.55 17.3Z"/>',
  viewBox: [0, 0, 24, 24],
};
